<template>
  <div style="width:100%;">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames" style="margin-top: 60px;">
      <van-collapse-item title="客户基本信息" name="1">
        <van-field v-model="inputForm.baseInfo.customerName" label="客户名称" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.customerCategoryName" label="客户类别" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.identityTypeName" label="证件类型" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.identityCode" label="证件号码" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.sexName" label="性别" label-width="130px" v-if="inputForm.baseInfo.customerCategory === '1'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.birthdate" label="出生年月" label-width="130px" v-if="inputForm.baseInfo.customerCategory === '1'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.nation" label="民族" label-width="130px" v-if="inputForm.baseInfo.customerCategory === '1'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.birthplace" label="籍贯" label-width="130px" v-if="inputForm.baseInfo.customerCategory === '1'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.homeAddress" label="户籍地址" label-width="130px" v-if="inputForm.baseInfo.customerCategory === '1'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.legalPerson" label="法定代表人" label-width="130px" v-if="inputForm.baseInfo.customerCategory === '2'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.legalPersonMobile" label="法定代表人联系电话" label-width="130px" v-if="inputForm.baseInfo.customerCategory === '2'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.isDeveloper" label="是否开发商" label-width="130px" v-if="inputForm.baseInfo.customerCategory === '2'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.baseInfo.remarks" label="备注" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <div style="padding-left: 16px;" v-show="inputForm.baseInfo.attachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.baseInfo.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
<!--        <div style="padding-left: 16px;">-->
<!--          <p>附件</p>-->
<!--          <a class="m-row" style="display: block; color: #4caedc" v-for="file in inputForm.baseInfo.attachList" :href="file.url">{{file.name}}</a>-->
<!--          <div class="m-row" v-if="inputForm.baseInfo.attachList&&inputForm.baseInfo.attachList.length==0">无</div>-->
<!--        </div>-->
      </van-collapse-item>
      <van-collapse-item title="项目预留信息" name="2">
        <van-field v-model="inputForm.projectName" label="物业项目名称" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.education" label="学历" label-width="130px" v-if="inputForm.baseInfo.customerCategory === '1'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.principalName" label="负责人姓名" label-width="130px" v-if="['2', '3'].includes(inputForm.baseInfo.customerCategory)" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.mobile" label="联系电话" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.wechatTel" label="微信绑定手机号" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.currentAddress" label="现住地址" label-width="130px" v-if="inputForm.baseInfo.customerCategory === '1'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.linkmanInfo" label="紧急联系人及联系电话" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.clan" label="所在党派、社团及任职情况" label-width="130px" v-if="inputForm.baseInfo.customerCategory === '1'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.workingInfo" label="工作单位及任职情况" label-width="130px" v-if="inputForm.baseInfo.customerCategory === '1'" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.bankInfo" label="银行账号" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.isEnabled==1?'是':'否'" label="是否启用" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <van-field v-model="inputForm.remarks" label="备注" label-width="130px" readonly autosize rows='1'
                   type="textarea"/>
        <div style="padding-left: 16px;" v-show="inputForm.attachList.length > 0">
          <p>附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index" @click="$viewAttach(file)">{{file.name}}</p>
        </div>
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import TaskService from '@/api/flowable/TaskService.js'
import ProcessService from '@/api/flowable/ProcessService'
import processRecord from "@/components/processRecord/processRecord";

export default {
  data() {
    return {
      activeNames: ['1', '2'],
      isshow: false,
      radio: '',
      inputForm: {
        id: "",
        customerId: "",
        projectId: "",
        education: "",
        principalName: "",
        mobile: "",
        wechatTel: "",
        currentAddress: "",
        linkmanInfo: "",
        clan: "",
        workingInfo: "",
        bankInfo: "",
        isEnabled: "1",
        remarks: "",
        attachIds: [],
        attachList: [],
        result: 0,
        baseInfo: {
          id: "",
          customerCategory: "",
          customerName: "",
          sex: "",
          birthdate: "",
          nation: "",
          birthplace: "",
          identityType: "",
          identityCode: "",
          homeAddress: "",
          isEnabled: "",
          legalPerson: "",
          legalPersonMobile: "",
          isDeveloper: "",
          remarks: "",
          attachIds: [],
          attachList: []
        },
        isDoTask: false,
        isLastTask: false
      },
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      businessId: '',
      type: ''
    }
  },
  components: {
    processRecord
  },
  mounted() {
  },
  created() {
    let query = this.$route.query;
    this.businessId = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    // let id = this.$cookie.get('id')
    // this.taskId = this.$cookie.get('taskId')
    // this.taskDefKey = this.$cookie.get('taskDefKey')
    // this.procInsId = this.$cookie.get('procInsId')
    // this.procDefId = this.$cookie.get('procDefId')
    this.init(this.businessId)
    // this.init('1744989073816236033')

  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/base/wuyeBaseCustomerProject/queryById').then(({ data }) => {
        this.inputForm = data
      }).catch(e => {
        console.log(e)
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        vars = {...vars, ..._this.inputForm}
        _this.auditForm.message = _this.inputForm.remarks

        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'

        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          businessTable: 'wuye_base_customer_project',
          businessId: this.businessId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          // if(data.code === 200) {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = _this.inputForm.isLastTask ? 4 : 2;
          _this.$flow.startFlow(_this.inputForm, '/base/wuyeBaseCustomerProject/startFlow')

          setTimeout(function () {
            _this.close()
          }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          // if(data.code === 200) {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          _this.inputForm.flowType = 3;
          _this.$flow.startFlow(_this.inputForm, '/base/wuyeBaseCustomerProject/startFlow')

          setTimeout(function () {
            _this.close()
          }, 800)
          // } else {
          //   _this.$toast.clear();
          //   _this.$toast.fail(data.msg);
          //   setTimeout(function () {
          //     _this.close()
          //   }, 800)
          // }
        })
      }).catch(() => {
      })
    }
  }
}
</script>
